import type { FC, ReactNode } from 'react'

import { TreeDeciduous } from 'lucide-react'
import { cn } from '@/lib/utils'

import { siteConfig } from '@/constants/site'

interface LogoProps {
    className?: string
    light?: boolean
}

export const Logo: FC<LogoProps> = ({ className, light = false }): ReactNode => {
    return (
        <span className={cn('flex items-center gap-3', className)}>
            <span
                aria-hidden='true'
                className={cn(
                    'grid size-10 place-items-center rounded-full border transition-colors duration-300',
                    light ? 'border-linen/30 bg-linen/10 text-linen' : 'border-forest/25 bg-forest-soft text-forest'
                )}
            >
                <TreeDeciduous className='size-5' strokeWidth={1.75} />
            </span>

            <span className='font-heading text-xl leading-none font-semibold tracking-tight'>
                {siteConfig.name}
            </span>
        </span>
    )
}
